<template>
  <div class="loading-container">
    <img src="../../www/asset/img/huoyuyan-loading.svg" alt="加载"/>
    数据加载中……
  </div>
</template>
<script>
export default {
  name: 'LoadingContainer',
  data () {
    return {}
  },
  mounted () {}
}
</script>